import React from "react";
import { Tabs } from "../../widgets";

function CollectionTabs(props) {
  const { value, handleChange } = props;
  return (
    <Tabs
      tabs={[
        { key: "vehicle", display: "Vehicle Wise" },
        { key: "day", display: "Day Wise" },
      ]}
      activeTab={value}
      onTabSelection={(key) => {
        handleChange("true", key);
      }}
    />
  );
}

export default CollectionTabs;
